import { getAxiosClient } from "src/utils/axios";
export const getHasCanUseCoupon =
  ({ userId }) =>
  async (dispatch) => {
    if (!userId) return;
    const cli = getAxiosClient("hasCanUseCoupon");

    try {
      return await cli.get(`/any/coupon/is-active`);
    } catch (e) {
      console.log(e);
    }
  };

export const getCouponList =
  ({ isExchanged, userId }) =>
  async (dispatch) => {
    if (!userId) return;
    const cli = getAxiosClient(
      `${isExchanged ? "exchanged" : "available"}Coupon`
    );
    const params = {
      isRedeemed: isExchanged,
      page: 1,
      size: 50,
    };
    try {
      await cli.get(`/${userId}/coupon`, { params });
    } catch (e) {
      console.log(e);
    }
  };

export const getCoupon =
  ({ couponId, userId }) =>
  async (dispatch) => {
    if (!couponId || !userId) return;
    const cli = getAxiosClient("coupon");
    try {
      await cli.get(`/${userId}/coupon/${couponId}`);
    } catch (e) {
      console.log(e);
    }
  };

export const postCoupon =
  ({ redeemCode, couponId, userId, utm }) =>
  async (dispatch) => {
    if (!userId || !couponId) return;
    const cli = getAxiosClient();
    try {
      const res = await cli.post(`/${userId}/coupon/${couponId}/redeem`, {
        redeemCode,
        utm,
      });
      return res;
    } catch (e) {
      console.log(e);
    }
  };
